import { styled } from "goober";
import type { ReactNode } from "react";
import { Noodle } from "./Noodle";

const Row = styled("div")`
  display: flex;
  min-width: 0;
  gap: 2px;

  &[data-nested] {
    margin-left: 16px;
  }
`;

const Rail = styled("div")`
  display: flex;
  width: 12px;
  flex-shrink: 0;
  transform: translateX(-0.5px);
`;

const Content = styled("div")`
  flex: 1;
  min-width: 0;
  padding-bottom: 2px;

  &[data-last] {
    padding-bottom: 0;
  }
`;

export function NavigationTreeRow({
  children,
  nested = true,
  last = false,
}: {
  children: ReactNode;
  nested?: boolean;
  last?: boolean;
}) {
  return (
    <Row data-nested={nested || undefined}>
      {nested && (
        <Rail aria-hidden>
          <Noodle gridSize={8} variant={last ? "terminate" : "branch"} />
        </Rail>
      )}
      <Content data-last={last || undefined}>{children}</Content>
    </Row>
  );
}
